import { render, staticRenderFns } from "./GdprDeletion.vue?vue&type=template&id=7c002888&scoped=true"
import script from "./GdprDeletion.vue?vue&type=script&lang=js"
export * from "./GdprDeletion.vue?vue&type=script&lang=js"
import style0 from "./GdprDeletion.vue?vue&type=style&index=0&id=7c002888&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c002888",
  null
  
)

export default component.exports